import React from 'react'

export default function Loading({loading, addClass}) {
    return (
        <div className={`page-loader ${!loading ? "hidden" : ""} ${addClass !== undefined ? addClass : ""}`} >
            <em className="fas fa-circle-notch fa-spin fa-2x text-color-theme"></em>
        </div>
    )
}